import React, { useState, useCallback, useEffect } from 'react'
import './Content.scss'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar'
import { FaNewspaper } from 'react-icons/fa'
import {
  IoIosNotifications,
  IoMdAlert,
  IoMdInformationCircle,
  IoIosCompass,
  IoIosDocument,
  IoIosPeople
} from 'react-icons/io'
import { GiHamburgerMenu } from 'react-icons/gi'
import { BiPlus, BiDotsHorizontalRounded } from 'react-icons/bi'
import { RiDragMove2Line } from 'react-icons/ri'
import DeleteMenuCustom from './DeleteMenuCustom'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { useCMSContext } from './../CMSContext'
import MenuSectionActions from './MenuSectionActions'
import { useMenuSectionContext } from './MenuSectionContext'
import { IARDialog } from '../../Shared/Dialog/IARDialog'
import RecruitmentActions from '../Content/Recruitment/RecruitmentActions'
import { useNavigate, useLocation } from 'react-router-dom'
import ROUTES_ENUM from '../../../Constants/routesEnum'
import SavingLabel from './SavingLabel'
import { Launch } from '@mui/icons-material'
import Grid from '@mui/material/Grid'
import './MenuSection.scss'

const MenuSection = ({
  rtl,
  image,
  toggled,
  collapsed,
  setSection,
  showDeleteCustom,
  handleToggleSidebar,
  setShowDeleteCustom
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isItemActive, setItemActive] = useState('department-info')
  // const[customSections, setCustomSections] = useState([])
  const menuSectionContext = useMenuSectionContext()
  const {
    disabledSort,
    customSections,
    marketingSections,
    previewSection,
    recruitmentName,
    customSectionsSaving,
    disableWelcomeOption,
    disableRecruitmentOption,
    disableGalleryOption,
    disableDonateOption,
    disableResourcesOption,
    lastCustomSectionId,
    newSectionSaving,
    galleryName,
    donateName
  } = menuSectionContext.state
  const {
    setCustomSections,
    setMenuMarketingSections,
    setRecruitmentName,
    setPreviewSection,
    setLastCustomSectionId,
    setGalleryName,
    setDonateName
  } = menuSectionContext.actions
  const [positions, setPositions] = useState({ position: 'absolute', top: 0, left: 0 })
  const [customSelected, setCustomSelected] = useState({})
  const cmsContext = useCMSContext()
  const { setSectionTitle, setSectionId, setSectionOrder, setIsMarketing } = cmsContext.actions
  const {
    fireDepartment,
    disableCMSOptions,
    disableCMSOptionsFull,
    appConfiguration,
    isMcsEnabled,
    isReadOnlyMember,
    iarMember,
    isCustomSectionBeingSaved
  } = cmsContext.state
  const [dialog, setDialog] = useState({ open: false })

  const activeStyle = { color: '#1C9CD5' }

  const isAlertsRouteActive = location.pathname === ROUTES_ENUM.alerts.pathname
  const isResourcesRouteActive = location.pathname === ROUTES_ENUM.resources.pathname

  useEffect(() => {
    if (isAlertsRouteActive) {
      setSection(ROUTES_ENUM.alerts.id)
      setItemActive(ROUTES_ENUM.alerts.id)
      setSectionTitle(ROUTES_ENUM.alerts.title)
      setSectionId('')
      setIsMarketing(false)
    }

    if (isResourcesRouteActive) {
      setSection(ROUTES_ENUM.resources.id)
      setItemActive(ROUTES_ENUM.resources.id)
      setSectionTitle(ROUTES_ENUM.resources.title)
      setSectionId('')
      setIsMarketing(false)
    }
  }, [
    navigate,
    setSection,
    setSectionTitle,
    setSectionId,
    isAlertsRouteActive,
    isResourcesRouteActive,
    setIsMarketing
  ])

  useEffect(() => {
    if (disableCMSOptionsFull) {
      if (disableCMSOptions || isAlertsRouteActive) {
        setSection(ROUTES_ENUM.alerts.id)
        setItemActive(ROUTES_ENUM.alerts.id)
        setSectionTitle(ROUTES_ENUM.alerts.title)
        setSectionId('')
        setIsMarketing(false)
      } else {
        navigate('/')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableCMSOptions, isAlertsRouteActive, disableCMSOptionsFull, setIsMarketing])

  useEffect(() => {
    if (fireDepartment && !isCustomSectionBeingSaved) {
      fetchCustomSections()
    }
  }, [fireDepartment, setCustomSections])

  useEffect(() => {
    if (fireDepartment) {
      async function getMarketingSectionsByDepartment() {
        const response = await MenuSectionActions.getMarketingSectionsByDepartment(fireDepartment)
        setMenuMarketingSections(response)
      }

      getMarketingSectionsByDepartment()
    }
  }, [fireDepartment, setMenuMarketingSections])

  useEffect(() => {
    if (fireDepartment) {
      async function fetchMenuSettings() {
        const response = await MenuSectionActions.getMenuSettings(fireDepartment.identifier)
        if (response) {
          const gallery = response ? response.gallery : ''
          const donate = response ? response.donate : ''
          setDonateName(donate)
          setGalleryName(gallery)
        }
      }
      fetchMenuSettings()
    }
  }, [fireDepartment, setGalleryName, setDonateName])

  useEffect(() => {
    if (fireDepartment) {
      async function fetchRecruitmentName() {
        const listOfRecruitmentName = [
          { value: 0, text: 'Recruitment' },
          { value: 1, text: 'Join Now' },
          { value: 2, text: 'Join Us' }
        ]

        const recruitmentResponse = await RecruitmentActions.getRecruitment(
          fireDepartment.identifier
        )
        if (recruitmentResponse) {
          setRecruitmentName(
            listOfRecruitmentName.find((el) => el.value === recruitmentResponse.sectionName).text
          )
        }
      }
      fetchRecruitmentName()
    }
  }, [fireDepartment, setRecruitmentName])

  // eslint-disable-next-line react-hooks/exhaustive-deps

  async function fetchCustomSections() {
    const response = await MenuSectionActions.getCustomSections(fireDepartment.identifier)
    setCustomSections(response)
  }

  const onClickMenu = useCallback(
    (evt) => {
      setSection(evt.currentTarget.id)
      setSectionTitle(evt.currentTarget.textContent)
      if (
        evt.currentTarget.getAttribute('isadded') &&
        evt.currentTarget.getAttribute('isadded') === 'false'
      ) {
        setSectionId(evt.currentTarget.id)
        setIsMarketing(false)
      } else if (
        evt &&
        evt.currentTarget &&
        evt.currentTarget.attributes &&
        evt.currentTarget.attributes.getNamedItem('type') &&
        evt.currentTarget.attributes.getNamedItem('type').nodeValue === 'marketing'
      ) {
        setSectionId(evt.currentTarget.id)
        setIsMarketing(true)
        setLastCustomSectionId(evt.currentTarget.id)
      } else if (
        evt.currentTarget.getAttribute('isadded') &&
        evt.currentTarget.getAttribute('isadded') === 'true'
      ) {
        setSectionId(evt.currentTarget.id)
        setIsMarketing(false)
      } else {
        setSectionId('')
        setIsMarketing(false)
      }
      if (evt.currentTarget.getAttribute('order')) {
        setSectionOrder(parseInt(evt.currentTarget.getAttribute('order')))
      }
      setItemActive(evt.currentTarget.id)
    },
    [
      setIsMarketing,
      setLastCustomSectionId,
      setSection,
      setSectionId,
      setSectionOrder,
      setSectionTitle
    ]
  )

  const onClickDeleteCustomSection = useCallback(
    (evt) => {
      setCustomSelected(evt.currentTarget.id)
      setPositions({ position: 'relative', top: evt.pageY - 145, left: 175 })
      setShowDeleteCustom(!showDeleteCustom)
    },
    [setShowDeleteCustom, showDeleteCustom]
  )

  const onClickAddCustom = useCallback(
    (evt) => {
      let isThereAnyNonSavedNewSection = customSections.some((section) =>
        section.id.startsWith('customSection')
      )

      if (isThereAnyNonSavedNewSection === false) {
        setCustomSections([
          ...customSections,
          {
            title: `Section`,
            order: customSections.length,
            id: 'customSection',
            isAdded: 'true'
          }
        ])

        setPreviewSection(true)
      }
      // eslint-disable-next-line no-use-before-define
    },
    [customSections, setCustomSections, setPreviewSection]
  )

  const handleMenuClickAway = useCallback(() => {
    if (showDeleteCustom) {
      setShowDeleteCustom(false)
    }
  }, [showDeleteCustom, setShowDeleteCustom])

  //dnd
  const reorder = useCallback((list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    result.forEach((el, index) => {
      el.order = index
    })

    return result
  }, [])

  const grid = 1

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    // styles we need to apply on draggables
    ...draggableStyle
  })

  const onDragEnd = useCallback(
    (evt) => {
      // dropped outside the list
      if (!evt.destination) {
        return
      }

      const items = reorder(customSections, evt.source.index, evt.destination.index)

      let listToReorderPost = []
      // eslint-disable-next-line array-callback-return
      items.map((el) => {
        if (el.id.indexOf('Section') === -1 && !el.onlyPreview) {
          listToReorderPost.push({
            _id: el.id,
            order: el.order
          })
        }
      })
      setCustomSections(items)

      async function customSectionReorderPost() {
        let requestSucceed = await MenuSectionActions.customSectionReorderPost(listToReorderPost)

        if (requestSucceed) setSectionOrder(evt.destination.index)
      }

      customSectionReorderPost()
    },
    [customSections, reorder, setCustomSections]
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const getListStyle = useCallback((isDraggingOver) => {
    return {
      padding: grid,
      width: 250
    }
  }, [])

  const deleteCustomSection = useCallback(
    (evt) => {
      let array = [...customSections]
      let indexDeleted = array.findIndex((el) => el.id === customSelected)
      setPreviewSection(false)
      if (indexDeleted !== -1) {
        array.splice(indexDeleted, 1)
        async function deleteCustomSections(customId) {
          if (customId && customId !== 'customSection') {
            const response = await MenuSectionActions.deleteCustomSections(customId)
            if (response) {
              const customs = await MenuSectionActions.getCustomSections(fireDepartment.identifier)
              setPositions({ position: 'absolute', top: 0, left: 0 })
              setCustomSections(customs)
              setSection('department-info')
              setSectionTitle('Entity Information')
              setItemActive('department-info')
              setSectionId('department-info')

              if (customId.startsWith('customSection')) {
                setPreviewSection(false)
              }
            }
          } else {
            const customs = await MenuSectionActions.getCustomSections(fireDepartment.identifier)
            setCustomSections(customs)
            setPositions({ position: 'absolute', top: 0, left: 0 })
            setSection('department-info')
            setPreviewSection(false)
            setSectionTitle('Entity Information')
            setItemActive('department-info')
            setSectionId('department-info')
          }
        }
        deleteCustomSections(customSelected)
        setDialog({ open: false })
      }
    },
    [
      customSections,
      customSelected,
      fireDepartment,
      setCustomSections,
      setSection,
      setSectionTitle,
      setSectionId,
      setPreviewSection
    ]
  )

  const openConfirmationDialog = useCallback(() => {
    setDialog({ open: true })
  }, [])

  const cancelDialog = useCallback(() => {
    setPositions({ position: 'absolute', top: 0, left: 0 })
    setDialog({ open: false })
  }, [])

  const block = (e, id) => {
    if (customSectionsSaving && customSectionsSaving.length > 0) {
      const isAnyNewCustomSectionSaving = customSectionsSaving.some((cs) => cs === 'customSection')

      // For now whenever we are saving a new custom section
      // we must block any click for other custom sections
      if (isAnyNewCustomSectionSaving) return e.preventDefault()

      const customToBlock = customSectionsSaving.find((i) => i === id)
      if (customToBlock && customToBlock.length > 0) {
        return e.preventDefault()
      } else {
        if (lastCustomSectionId !== id) {
          onClickMenu(e)
          setLastCustomSectionId(id)
        } else {
          return e.preventDefault()
        }
      }
    } else {
      if (lastCustomSectionId !== id) {
        onClickMenu(e)
        setLastCustomSectionId(id)
      } else {
        return e.preventDefault()
      }
    }
  }
  const contentDialog =
    appConfiguration && appConfiguration.previewEnabled ? (
      <Grid container>
        <Grid size={12}>
          Do you want to delete this custom section?
        </Grid>
        <Grid size={12}>
          This action will delete published and preview content.
        </Grid>
      </Grid>
    ) : (
      'Do you want to delete this custom section?'
    )

  return (
    <>
      <IARDialog
        open={dialog.open}
        title="Confirm"
        content={contentDialog}
        onOk={deleteCustomSection}
        onCancel={cancelDialog}
      />
      <DeleteMenuCustom
        deleteCustomSection={openConfirmationDialog}
        styles={{ position: positions.position, top: positions.top, left: positions.left }}
        isMenuActive={showDeleteCustom}
      />
      <ClickAwayListener onClickAway={handleMenuClickAway}>
        <Sidebar
          rtl={rtl}
          collapsed={collapsed}
          toggled={toggled}
          breakPoint="md"
          onBackdropClick={handleToggleSidebar}
          backgroundColor="white"
          width="270px"
        >
            <div>
              {disableCMSOptionsFull ? (
                disableCMSOptions ? (
                  <Menu>
                    <MenuItem
                      id="alerts"
                      title="Alerts"
                      style={isItemActive === 'alerts' ? activeStyle : {}}
                      onClick={onClickMenu}
                      icon={<IoMdAlert />}
                    >
                      Alerts
                    </MenuItem>
                  </Menu>
                ) : (
                  <div>
                    <Menu>
                      <MenuItem
                        id="department-info"
                        title="department-info"
                        style={isItemActive === 'department-info' ? activeStyle : {}}
                        onClick={onClickMenu}
                        icon={<IoMdInformationCircle />}
                      >
                        <span>Entity Information</span>
                      </MenuItem>
                    </Menu>
                    {iarMember?.isCommunityAppEnabled ? (
                      <Menu>
                        <MenuItem
                          id="resources"
                          title="Resources"
                          className="resources"
                          icon={<Launch />}
                          style={isItemActive === 'resources' ? activeStyle : {}}
                          onClick={disableResourcesOption ? (e) => e.preventDefault() : onClickMenu}
                        >
                          <SavingLabel active={disableResourcesOption} />
                          <span>
                            Implementation <br />
                            Resources
                          </span>
                        </MenuItem>
                      </Menu>
                    ) : (
                      <></>
                    )}
                    <Menu>
                      <SubMenu label="Menu Sections" icon={<GiHamburgerMenu />}>
                        <div>
                          <MenuItem
                            id="home"
                            title="Home"
                            style={isItemActive === 'home' ? activeStyle : {}}
                            onClick={disableWelcomeOption ? (e) => e.preventDefault() : onClickMenu}
                          >
                            <SavingLabel active={disableWelcomeOption} />
                            <span>Home</span>
                          </MenuItem>
                          <MenuItem
                            id="gallery"
                            title={galleryName}
                            style={isItemActive === 'gallery' ? activeStyle : {}}
                            onClick={disableGalleryOption ? (e) => e.preventDefault() : onClickMenu}
                          >
                            <SavingLabel active={disableGalleryOption} />
                            <span>{galleryName}</span>
                          </MenuItem>
                          <MenuItem
                            id="donate"
                            title={donateName}
                            style={isItemActive === 'donate' ? activeStyle : {}}
                            onClick={disableDonateOption ? (e) => e.preventDefault() : onClickMenu}
                          >
                            <SavingLabel active={disableDonateOption} />
                            <span>{donateName}</span>
                          </MenuItem>
                          <MenuItem
                            id="recruitment"
                            title={recruitmentName}
                            style={isItemActive === 'recruitment' ? activeStyle : {}}
                            onClick={
                              disableRecruitmentOption ? (e) => e.preventDefault() : onClickMenu
                            }
                          >
                            <SavingLabel active={disableRecruitmentOption} />
                            <span>{recruitmentName}</span>
                          </MenuItem>
                          <MenuItem
                            id="contact"
                            title="Contact"
                            style={isItemActive === 'contact' ? activeStyle : {}}
                            onClick={onClickMenu}
                          >
                            Contact Us
                          </MenuItem>
                        </div>
                        <div className="customSectionDiv">
                          <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                              {(provided, snapshot) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                >
                                  {customSections.map((el, index) => {
                                    if (el.onlyPreview) return null
                                    return (
                                      <Draggable
                                        draggableId={el.id ? el.id : el.title ? el.title : index}
                                        key={el.id ? el.id : el.title ? el.title : index}
                                        index={index}
                                        isDragDisabled={
                                          disabledSort || previewSection ? true : false
                                        }
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          >
                                            <MenuItem
                                              key={el.id}
                                              id={el.id}
                                              style={isItemActive === el.id ? activeStyle : {}}
                                              title={el.title}
                                              order={el.order}
                                              isadded={el.isAdded}
                                              onClick={(e) => block(e, el.id)}
                                            >
                                              {disabledSort || previewSection ? (
                                                <></>
                                              ) : (
                                                <RiDragMove2Line />
                                              )}
                                              <div className="textSection">
                                                {customSectionsSaving.length > 0
                                                  ? customSectionsSaving.map((i) =>
                                                      i === el.id ? (
                                                        <SavingLabel active={true} />
                                                      ) : (
                                                        ''
                                                      )
                                                    )
                                                  : ''}
                                                {el.title}
                                              </div>
                                              <>
                                                {!disabledSort ? (
                                                  <>
                                                    {isItemActive !== el.id ? (
                                                      <BiDotsHorizontalRounded
                                                        className="dotSection"
                                                        onClick={onClickDeleteCustomSection}
                                                        id={el.id}
                                                      />
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            </MenuItem>
                                          </div>
                                        )}
                                      </Draggable>
                                    )
                                  })}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                          {customSections.map((el) => {
                            if (el.onlyPreview && appConfiguration?.previewEnabled) {
                              return (
                                <MenuItem
                                  key={el.id}
                                  id={el.id}
                                  style={isItemActive === el.id ? activeStyle : {}}
                                  title={el.title}
                                  order={el.order}
                                  isadded={el.isAdded}
                                  onClick={(e) => block(e, el.id)}
                                >
                                  <div className="textSection">
                                    {customSectionsSaving.length > 0
                                      ? customSectionsSaving.map((i) =>
                                          i === el.id ? <SavingLabel active={true} /> : ''
                                        )
                                      : ''}
                                    {el.title}
                                  </div>
                                  <>
                                    {!disabledSort ? (
                                      <>
                                        {isItemActive !== el.id ? (
                                          <BiDotsHorizontalRounded
                                            className="dotSection"
                                            onClick={onClickDeleteCustomSection}
                                            id={el.id}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                </MenuItem>
                              )
                            }
                            return null
                          })}

                          {marketingSections && marketingSections.length > 0 ? (
                            marketingSections.map((el) => (
                              <MenuItem
                                key={el.id + el.title}
                                id={el.id}
                                title={el.title}
                                type={'marketing'}
                                style={isItemActive === el.id ? activeStyle : {}}
                                onClick={onClickMenu}
                              >
                                <div className="textSection">{el.title}</div>
                              </MenuItem>
                            ))
                          ) : (
                            <></>
                          )}
                          {newSectionSaving.length > 0 ? (
                            <MenuItem id="saving" className="addSection">
                              <span> ...Saving Sections</span>
                            </MenuItem>
                          ) : (
                            <></>
                          )}
                          {customSections.length < 10 &&
                          newSectionSaving.length === 0 &&
                          customSectionsSaving.length === 0 &&
                          !isReadOnlyMember &&
                          !previewSection ? (
                            <MenuItem
                              id="addCustom"
                              className="addSection"
                              onClick={onClickAddCustom}
                            >
                              <BiPlus className="svg" />
                              <span> Add Section</span>
                            </MenuItem>
                          ) : (
                            <></>
                          )}
                          {!iarMember?.isImpersonating && isReadOnlyMember && isMcsEnabled ? (
                            <MenuItem
                              id="addMarketingCustom"
                              className="addSection"
                              onClick={onClickMenu}
                            >
                              <BiPlus className="svg" />
                              <span> Marketing Section</span>
                            </MenuItem>
                          ) : (
                            <></>
                          )}
                        </div>
                      </SubMenu>
                    </Menu>
                    <Menu>
                      <MenuItem
                        id="news"
                        title="News"
                        style={isItemActive === 'news' ? activeStyle : {}}
                        icon={<FaNewspaper />}
                        onClick={onClickMenu}
                      >
                        News
                      </MenuItem>
                    </Menu>
                    <Menu>
                      <MenuItem
                        id="notifications"
                        title="Notifications"
                        style={isItemActive === 'notifications' ? activeStyle : {}}
                        onClick={onClickMenu}
                        icon={<IoIosNotifications />}
                      >
                        Notifications History
                      </MenuItem>
                    </Menu>
                    <Menu>
                      <MenuItem
                        id="alerts"
                        title="Alerts"
                        style={isItemActive === 'alerts' ? activeStyle : {}}
                        onClick={onClickMenu}
                        icon={<IoMdAlert />}
                      >
                        Alerts
                      </MenuItem>
                    </Menu>
                    {fireDepartment && fireDepartment.enableEntryOfResidentialPlan ? (
                      <Menu>
                        <MenuItem
                          id="residentialplans"
                          title="Residential Plans"
                          style={isItemActive === 'residentialplans' ? activeStyle : {}}
                          onClick={onClickMenu}
                          icon={<IoIosCompass />}
                        >
                          Residential Plans
                        </MenuItem>
                      </Menu>
                    ) : (
                      <></>
                    )}
                    <Menu>
                      <MenuItem
                        id="residentialPlansReport"
                        title="Properties Report"
                        style={isItemActive === 'residentialPlansReport' ? activeStyle : {}}
                        onClick={onClickMenu}
                        icon={<IoIosDocument />}
                      >
                        Properties Report
                      </MenuItem>
                    </Menu>
                    <Menu>
                      <MenuItem
                        id="transactionsReport"
                        title="Transactions Report"
                        style={isItemActive === 'transactionsReport' ? activeStyle : {}}
                        onClick={onClickMenu}
                        icon={<IoIosDocument />}
                      >
                        Transactions Report
                      </MenuItem>
                    </Menu>
                    {appConfiguration && appConfiguration.previewEnabled ? (
                      <Menu>
                        <MenuItem
                          id="Prepublish Members"
                          title="Pre-publish member list"
                          style={isItemActive === 'Prepublish Members' ? activeStyle : {}}
                          onClick={onClickMenu}
                          icon={<IoIosPeople />}
                        >
                          Preview Ability
                        </MenuItem>
                      </Menu>
                    ) : null}
                  </div>
                )
              ) : null}
            </div>
        </Sidebar>
      </ClickAwayListener>
    </>
  )
}

export default MenuSection
